import { email, maxLength, required, TextInput, useNotify } from "react-admin";
import { Grid } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

import { settings } from "app";
import LoadingActionButton from "server/components/LoadingActionButton";
import FormModal from "server/components/Modals/FormModal";
import { documentErrorMessage } from "server/components/DownloadFile";
import { download } from "server/download";

// Unlike the other generated erasmus documents, the certificate of arrival needs three values the
// record does not carry - the coordinator fills them in and they travel as query parameters.
// `buildUrl` is the tenant-specific builder (regular student / internship student).
const CertificateOfArrivalButton = ({ buildUrl, fileName, label }) => {
  const notify = useNotify();

  const handleConfirm = async ({ hostUniversity, hostCountry, email: emailValue }) => {
    const url = `${settings.gatewayApi}/${buildUrl({
      hostUniversity,
      hostCountry,
      email: emailValue,
    })}`;

    try {
      // opens the generated pdf in a new tab - the modal closes only once it is generated
      await download(url, fileName, "GET", null, false);
    } catch (err) {
      // keep the modal open so the entered data can be corrected and the download retried
      notify(documentErrorMessage(err), { type: "error" });
      return false;
    }
  };

  return (
    <FormModal
      titleContent={label}
      dialogSize="md"
      saveTitle="Генерирай"
      onConfirm={handleConfirm}
      triggerButton={
        <LoadingActionButton
          label={label}
          icon={<PrintIcon />}
          width="auto"
          minWidth={220}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="hostUniversity"
            label="Приемащ университет"
            fullWidth
            validate={[required(), maxLength(200)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="hostCountry"
            label="Приемаща държава"
            fullWidth
            validate={[required(), maxLength(100)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="email"
            label="Имейл"
            fullWidth
            validate={[required(), email(), maxLength(100)]}
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default CertificateOfArrivalButton;
